'use client';

import { Box, useBreakpoints } from '@monorepo/nova-ui';
import { CartData } from '@monorepo/types';
import { LayoutHeader } from './layout-header-desktop';
import { LayoutHeaderMobile } from './layout-header-mobile';

interface HeaderProps {
  cartData?: CartData;
  isTransparent?: boolean;
  userId?: string;
}

export const Header = ({
  cartData = {},
  isTransparent = false,
  userId,
}: HeaderProps) => {
  const { isTablet, isDesktop, isMobile } = useBreakpoints();

  return (
    <Box component="header" className="new-header">
      {isDesktop && (
        <LayoutHeader
          cartData={cartData}
          isTransparent={isTransparent}
          userId={userId}
        />
      )}
      {isTablet && (
        <LayoutHeaderMobile
          cartData={cartData}
          isTransparent={isTransparent}
          userId={userId}
        />
      )}
      {isMobile && (
        <LayoutHeaderMobile
          cartData={cartData}
          isTransparent={isTransparent}
          userId={userId}
        />
      )}
    </Box>
  );
};
